export const personalData = [
  {
    label: "שם:",
    value: "מתי גורפינקל ",
  },
  {
    label: "גיל:",
    value: "30 ",
  },
  {
    label: "כתובת: ",
    value: "לוד  ",
  },
  {
    label: "Email",
    value: "mtyg7702@gmail.com ",
  },
  {
    label: "יצירת קשר: ",
    value: "054-770-0019 ",
  },
];
